import { useVendorComponent } from '@steelbuy/vendor';

export const DashboardVendor = () => {
    const Dashboard = useVendorComponent('dashboard');

    return <Dashboard />;
};
